import React, { useEffect, useRef, useState } from "react";
import { RotatableCamera } from "./rotatableCamera";
import {
  SvgBullet,
  SvgCameraMapDelete,
  SvgCheck,
  SvgDomeBlue,
  SvgFanArea,
  SvgFishEyeBlue,
  SvgPTZBlue,
  SvgRotate,
  SvgSwitch,
  SvgTurrent,
} from "ui/svgs";
import { Popover } from "antd";
import { setCameraPosition } from "./service";
function capitalizeFirstLetter(string: string): string {
  if (!string) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export function AdvancedIcon({
  selected,
  onConfirm,
  poi,
  onDelete,
  highLighted,
}) {
  const svgRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [startAngle, setStartAngle] = useState(0);
  const [popOverOpen, setPopOverOpen] = useState(false);
  const [center, setCenter] = useState({ x: 0, y: 0 });
  const [cameraType, setCameraType] = useState("Dome");
  useEffect(() => {
    setRotation(poi.location.rotation);
    setCameraType(capitalizeFirstLetter(poi.location.type));
  }, [poi]);
  const onCameraDelete = async () => {
    const res = await setCameraPosition(poi.key, null);
    if (res.status !== 200) {
      console.error("Failed to delete camera position");
      return;
    }
    onDelete?.(poi);
  };
  const onMouseDown = (e: React.MouseEvent<SVGSVGElement>) => {
    setIsDragging(true);
    e.stopPropagation();
    const ele: any = svgRef.current;
    const rect = ele.getBoundingClientRect();
    const newCenter = {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    };
    setCenter(newCenter);
    const dx = e.clientX - newCenter.x;
    const dy = e.clientY - newCenter.y;
    const angle = Math.atan2(dy, dx) * (180 / Math.PI);
    setStartAngle(angle - rotation);
  };

  const onMouseMove = (e: MouseEvent) => {
    if (!isDragging) return;
    e.stopPropagation();
    const dx = e.clientX - center.x;
    const dy = e.clientY - center.y;
    const angle = Math.atan2(dy, dx) * (180 / Math.PI);
    setRotation(angle - startAngle);
  };

  const onMouseUp = () => {
    setIsDragging(false);
  };

  React.useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
    } else {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, [isDragging]);
  const onConfirmClick = async (e) => {
    const type = cameraType.toLowerCase();
    const res = await setCameraPosition(poi.key, {
      latitude: poi.location.lat,
      longitude: poi.location.lng,
      rotation: rotation,
      type,
    });
    if (res.status !== 200) {
      console.error("Failed to set camera position");
      return;
    }
    onConfirm?.(e);
  };
  const getIconByType = () => {
    switch (cameraType) {
      case "Dome":
        return (
          <SvgDomeBlue
            style={{ display: "inline-block" }}
            color={highLighted ? "#2BD87C" : undefined}
          />
        );
      case "Fisheye":
        return (
          <SvgFishEyeBlue
            style={{ display: "inline-block" }}
            color={highLighted ? "#2BD87C" : undefined}
          />
        );
      case "Ptz":
        return (
          <SvgPTZBlue
            style={{ display: "inline-block" }}
            color={highLighted ? "#2BD87C" : undefined}
          />
        );
      case "Turrent":
        return (
          <SvgTurrent
            style={{ display: "inline-block" }}
            color={highLighted ? "#2BD87C" : undefined}
          />
        );
      case "Bullet":
        return (
          <SvgBullet
            style={{ display: "inline-block" }}
            color={highLighted ? "#2BD87C" : undefined}
          />
        );
    }
  };
  return (
    <div style={{ display: "relative", height: "0px", width: "0px" }}>
      {/* {selected ? ( */}
      <div
        style={{
          color: "black",
          fontSize: "18px",
          position: "absolute",
          zIndex: 0,
          top: "-40px",
          left: "-50px",
          width: "100px",
          textAlign: "center",
          display: "block",
          whiteSpace: "nowrap",
          textShadow:
            "1px 1px 0 #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff",
        }}
      >
        {poi.name}
      </div>
      <div
        ref={svgRef}
        style={{
          width: "100px",
          height: "100px",
          transform: `translateY(-50%) translateX(-50%) rotate(${rotation}deg)`,
          border: selected ? "1px solid blue" : "none",
          alignContent: "center",
          textAlign: "center",
          position: "absolute",
        }}
      >
        {getIconByType()}
        <SvgFanArea
          style={{ position: "absolute", transform: "translateX(-21%)" }}
        />
        {selected && (
          <>
            <SvgCameraMapDelete
              style={{ position: "absolute", left: "0", top: "0" }}
              onClick={onCameraDelete}
            />
            <SvgRotate
              style={{ position: "absolute", right: "0", top: "0" }}
              onMouseDown={onMouseDown}
            />
            <SvgCheck
              style={{ position: "absolute", right: "0", bottom: "0" }}
              onClick={onConfirmClick}
            />
            <Popover
              overlayClassName="cameraMapPop"
              placement="bottom"
              content={
                <div
                  style={{
                    height: "130px",
                    width: "130px",
                    backgroundColor: "white",
                    borderRadius: "16px",
                    display: "grid",
                    gridTemplateColumns: "2fr 2fr",
                    justifyItems: "center",
                  }}
                >
                  <div
                    onClick={() => setCameraType("Dome")}
                    style={{
                      width: "65px",
                      height: "65px",
                      borderRadius: "16px",
                      alignContent: "center",
                      textAlign: "center",
                      backgroundColor:
                        cameraType === "Dome"
                          ? "rgba(220, 231, 253, 1)"
                          : "white",
                    }}
                  >
                    <SvgDomeBlue style={{ display: "inline-block" }} />
                    <div style={{ color: "black" }}>Dome</div>
                  </div>
                  {/* <div
                    onClick={() => setCameraType("Fisheye")}
                    style={{
                      width: "65px",
                      height: "65px",
                      borderRadius: "16px",
                      alignContent: "center",
                      textAlign: "center",
                      backgroundColor:
                        cameraType === "Fisheye"
                          ? "rgba(220, 231, 253, 1)"
                          : "white",
                    }}
                  >
                    <SvgFishEyeBlue style={{ display: "inline-block" }} />
                    <div style={{ color: "black" }}>Fisheye</div>
                  </div> */}
                  <div
                    onClick={() => setCameraType("Ptz")}
                    style={{
                      width: "65px",
                      height: "65px",
                      borderRadius: "16px",
                      alignContent: "center",
                      textAlign: "center",
                      backgroundColor:
                        cameraType === "Ptz"
                          ? "rgba(220, 231, 253, 1)"
                          : "white",
                    }}
                  >
                    <SvgPTZBlue style={{ display: "inline-block" }} />
                    <div style={{ color: "black" }}>PTZ</div>
                  </div>
                  <div
                    onClick={() => setCameraType("Turrent")}
                    style={{
                      width: "65px",
                      height: "65px",
                      borderRadius: "16px",
                      alignContent: "center",
                      textAlign: "center",
                      backgroundColor:
                        cameraType === "Turrent"
                          ? "rgba(220, 231, 253, 1)"
                          : "white",
                    }}
                  >
                    <SvgTurrent style={{ display: "inline-block" }} />
                    <div style={{ color: "black" }}>Turrent</div>
                  </div>
                  <div
                    onClick={() => setCameraType("Bullet")}
                    style={{
                      width: "65px",
                      height: "65px",
                      borderRadius: "16px",
                      alignContent: "center",
                      textAlign: "center",
                      backgroundColor:
                        cameraType === "Bullet"
                          ? "rgba(220, 231, 253, 1)"
                          : "white",
                    }}
                  >
                    <SvgBullet style={{ display: "inline-block" }} />
                    <div style={{ color: "black" }}>Bullet</div>
                  </div>
                </div>
              }
              trigger="click"
              open={popOverOpen}
              onOpenChange={setPopOverOpen}
            >
              <SvgSwitch
                onClick={() => setPopOverOpen(!popOverOpen)}
                style={{ position: "absolute", left: "0", bottom: "0" }}
              />
            </Popover>
          </>
        )}
      </div>
      {/* ) : (
        <RotatableCamera onClick={onClick} refs={svgRef} rotation={rotation} />
      )} */}
    </div>
  );
}
